// web/src/store/hooks.ts
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import type { AppDispatch, RootState } from './store';

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

/**
 * Returns true if the user has the given permission, false otherwise.
 * @param {string} permission The permission to check for.
 * @returns {boolean} True if the user has the permission, false otherwise.
 */
export const useUserHasPermissions = (permission: string): boolean => {
  const { permissions } = useAppSelector((state) => state.auth);
  return permissions.includes(permission);
};

/**
 * Returns true if the user has at least one of the given permissions, false otherwise.
 * @param {string[]} permission The permissions to check for.
 * @returns {boolean} True if the user has at least one of the given permissions, false otherwise.
 */
export const useUserHasAtLeastOnePermission = (
  permission: string[],
): boolean => {
  const { permissions } = useAppSelector((state) => state.auth);
  return permissions.some((p) => permission.includes(p));
};
